import React from 'react';

import { HeroStandard, MetaTags, GridStandard } from '../components';

import { Spacer } from '../components/Spacer';

import { allRoutes, normalizeCuratedContent, normalizePerson } from '../helpers';
import { graphql } from 'gatsby';

import styled from 'react-emotion';

const Title = styled.h2`
	font-size: 2rem;
	margin-bottom: 1rem;
`;

export default function OurLeaders({ data }) {
	const {
		boardOfDirectors,
		enterpriseLeaders,
		locationLeaders,
		projectTypeLeaders,
	} = data;
	
	const hero = data?.heroImage?.childImageSharp?.fluid;

	return (
		<main id="main">
			<MetaTags
				post_title="Our Leaders"
				description="At HKS, excellence starts with a commitment to the core values that define our organization."
			/>

			<HeroStandard
				hero={hero}
				heroAlt=""
				label="Our Leadership"
				post_title="At HKS, excellence starts with a commitment to the core values that define our organization."
				description="Above all, we value people and relationships, we prize character and hold ourselves to the highest ethical standards. We are united for a common purpose – to improve the health and wellbeing of all the communities we serve and to protect our planet. Our leadership embodies these values and charts the path forward for our continued growth, evolution and innovation."
				jumpLinks={[
					{
						name: 'Board of Directors',
						path: '#board-of-directors',
					},
					{
						name: 'Project Type Leaders',
						path: '#project-type-leaders',
					},
					{
						name: 'Location Leaders',
						path: '#location-leaders',
					},
					{
						name: 'Enterprise Leaders',
						path: '#enterprise-leaders',
					},
				]}
				cta="Meet Our Team"
				link={allRoutes.people}
			/>

			<div className="content-contain">
				{boardOfDirectors && (
					<>
						<Title id="board-of-directors">Board of Directors</Title>
						<GridStandard
							cardStyle="search"
							content={boardOfDirectors.nodes.map( normalizePerson )}
						/>
						<Spacer size={2} />
					</>
				)}
				
				{projectTypeLeaders && (
					<>
						<Title id="project-type-leaders">Project Type Leaders</Title>
						<GridStandard
							cardStyle="search"
							content={projectTypeLeaders.nodes.map( normalizePerson )}
						/>
						<Spacer size={2} />
					</>
				)}

				{locationLeaders && (
					<>
						<Title id="location-leaders">Location Leaders</Title>
						<GridStandard
							cardStyle="search"
							content={locationLeaders.nodes.map( normalizePerson )}
						/>
						<Spacer size={2} />
					</>
				)}

				{enterpriseLeaders && (
					<>
						<Title id="enterprise-leaders">Enterprise Leaders</Title>
						<GridStandard
							cardStyle="search"
							content={enterpriseLeaders.nodes.map( normalizePerson )}
						/>
						<Spacer size={4} />
					</>
				)}
			</div>
		</main>
	);
}

export const query = graphql`
	query {
		heroImage: file(relativePath: { eq: "our-leaders-hero-cropped.jpg" }) {
			childImageSharp {
				fluid(maxWidth: 2036) {
					...GatsbyImageSharpFluid_noBase64
				}
			}
		}

		boardOfDirectors: allWordsbyCollections(
			filter: {
				taxonomies: {
					leadership_group: {
						terms: { elemMatch: { name: { eq: "Board of Directors" } } }
					}
				}
			}
			sort: { fields: post_title }
		) {
			nodes {
				...PersonFields
			}
		}
		enterpriseLeaders: allWordsbyCollections(
			filter: {
				taxonomies: {
					leadership_group: {
						terms: { elemMatch: { name: { eq: "Enterprise Leaders" } } }
					}
				}
			}
			sort: { fields: post_title }
		) {
			nodes {
				...PersonFields
			}
		}
		locationLeaders: allWordsbyCollections(
			filter: {
				taxonomies: {
					leadership_group: {
						terms: { elemMatch: { name: { eq: "Location Leaders" } } }
					}
				}
			}
			sort: { fields: post_title }
		) {
			nodes {
				...PersonFields
			}
		}
		projectTypeLeaders: allWordsbyCollections(
			filter: {
				taxonomies: {
					leadership_group: {
						terms: { elemMatch: { name: { eq: "Project Type Leaders" } } }
					}
				}
			}
			sort: { fields: post_title }
		) {
			nodes {
				...PersonFields
			}
		}
	}
`;
